import { FuncionarioCentroCusto } from 'service/api'

import ApiService from '../api.service'

export const centroCustoFuncionario_api =
    new ApiService<FuncionarioCentroCusto>('centro-custos/funcionarios')
